import { render, staticRenderFns } from "./BgPattern.vue?vue&type=template&id=21c7afca&scoped=true&lang=pug&"
import script from "./BgPattern.vue?vue&type=script&lang=js&"
export * from "./BgPattern.vue?vue&type=script&lang=js&"
import style0 from "./BgPattern.vue?vue&type=style&index=0&id=21c7afca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7afca",
  null
  
)

export default component.exports